import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus2",
  "use": "minus2-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"minus2\">\n  <rect fill=\"currentColor\" width=\"400\" height=\"65\" transform=\"translate(51 220)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol